import { render, staticRenderFns } from "./StageAddSymptoms.vue?vue&type=template&id=bc6230cc"
import script from "./StageAddSymptoms.vue?vue&type=script&lang=js"
export * from "./StageAddSymptoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports